import { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  Typography,
  Box,
} from "@material-ui/core";
import Scrollbar from "src/components/Scrollbar";
import CustomTablePagination from "src/components/CustomTablePagination";
import FilaFacturacion from "src/components/facturacion/FilaFacturacion";

const COLUMNAS = [
  { id: "cliente", label: "Cliente", align: "left" },
  { id: "plan", label: "Plan", align: "left" },
  { id: "tipo", label: "Tipo", align: "left" },
  { id: "estado", label: "Estado", align: "left" },
  { id: "folio", label: "Folio", align: "right" },
  { id: "cantidad", label: "Cantidad", align: "right" },
  { id: "valor", label: "Valor", align: "right" },
  { id: "accion", label: "", align: "right" },
];

export default function TablaFacturacion({
  sucursal,
  items,
  data,
  soloLectura,
  permiso,
}) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);

  const sinPeriodo = !data || data.periodoId == null;

  if (sinPeriodo) {
    return (
      <Box sx={{ p: 6, textAlign: "center" }}>
        <Typography variant="subtitle1" gutterBottom>
          Aún no se ha preparado este periodo
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Use "Actualizar planes" para generar la lista de facturación desde los
          planes vigentes.
        </Typography>
      </Box>
    );
  }

  if (items.length === 0) {
    return (
      <Box sx={{ p: 6, textAlign: "center" }}>
        <Typography variant="body2" color="text.secondary">
          No hay resultados con los filtros aplicados.
        </Typography>
      </Box>
    );
  }

  const visibles = items.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );

  return (
    <Scrollbar>
      <TableContainer sx={{ minWidth: 900 }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {COLUMNAS.map((c) => (
                <TableCell key={c.id} align={c.align}>
                  {c.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {visibles.map((item) => (
              <FilaFacturacion
                key={item.id}
                item={item}
                sucursal={sucursal}
                soloLectura={soloLectura}
                permiso={permiso}
              />
            ))}
          </TableBody>
          <TableFooter>
            <TableRow>
              <CustomTablePagination
                count={items.length}
                rowsPerPage={rowsPerPage}
                page={page}
                colSpan={COLUMNAS.length}
                rowsPerPageOptions={[25, 50, 100]}
                onPageChange={(e, p) => setPage(p)}
                onRowsPerPageChange={(e) => {
                  setRowsPerPage(Number(e.target.value));
                  setPage(0);
                }}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
    </Scrollbar>
  );
}
